import { c as _c } from "react/compiler-runtime";
import { Trash02Icon } from '@systemeio/icons';
import React, { type JSX, type ReactNode } from 'react';
import { Button, IconTile } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface RuleStepHeaderProps {
  icon: JSX.Element;
  title: ReactNode;
  description: ReactNode;
  onDelete: () => void;
  dataTest?: string;
}

/**
 * Heading row of a single trigger/action step inside a `RuleCard`:
 * icon tile, title + description and the destructive "remove step" control.
 */
export function RuleStepHeader(t0) {
  const $ = _c(22);
  const {
    icon,
    title,
    description,
    onDelete,
    dataTest: t1
  } = t0;
  const dataTest = t1 === undefined ? "automation-rule-step-delete" : t1;
  const {
    t
  } = useLocoTranslation();
  let t2;
  if ($[0] !== icon) {
    t2 = <IconTile aria-hidden="true" tone="white">{icon}</IconTile>;
    $[0] = icon;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <span className="text-text-primary text-base font-medium">{title}</span>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description) {
    t4 = <span className="text-text-tertiary text-sm">{description}</span>;
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="flex min-w-0 flex-col gap-1">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <div className="flex min-w-0 items-start gap-3">{t2}{t5}</div>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("global.delete");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Trash02Icon />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== dataTest || $[16] !== onDelete || $[17] !== t7) {
    t9 = <Button aria-label={t7} data-test={dataTest} onClick={onDelete} size="icon-md" variant="gray">{t8}</Button>;
    $[15] = dataTest;
    $[16] = onDelete;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="flex items-start justify-between gap-3">{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}